export const adaptCPDPCost = (response) => {
  const _data = response?.response?.[0]?.['serviceTypeCost'];
  return _data ? _data : [];
};
